import "./commondialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog, showDialog } from "../../Actions/Dialogs/DialogActions";
import { pluralize } from "../../Utilities/Generic/Strings";
import Button from "../Buttons/Button";
import ClearLocalDataDialog from "./ClearLocalDataDialog";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

interface Props extends PropsFromRedux {
    queue: any;
}

export class ClearUploadQueueDialog extends React.Component<Props> {
    public handleContinueClick = (): void => {
        this.props.dispatch(showDialog(
            "Clear Local Data",
            <ClearLocalDataDialog />,
            "warning",
            false,
            false
        ));
    };

    public handleBackClick = (): void => {
        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        return (
            <div className="clear-uploads-dialog">
                <p><strong>Warning!</strong> Clearing local data will remove the following queued uploads.</p>
                <div className="uploads">
                    {Object.keys(this.props.queue.pending).map((type, index) => {
                        const count = this.props.queue.pending[type];
                        const typeString = pluralize(type, count);

                        return (
                            <div
                                key={"pending" + index}
                                className="upload pending"
                            >
                                Pending {typeString}: {count}
                            </div>
                        );
                    })}
                    {Object.keys(this.props.queue.failed).map((type, index) => {
                        return (
                            <div
                                key={"failed" + index}
                                className="upload failed"
                            >
                                Failed {pluralize(type, this.props.queue.failed[type])}: {this.props.queue.failed[type]}
                            </div>
                        );
                    })}
                </div>
                <p>This cannot be undone.</p>
                <div className="buttons">
                    <Button classes={[ "button-cancel" ]} onClick={this.handleBackClick}>Back</Button>
                    <Button classes={[ "button-danger" ]} onClick={this.handleContinueClick}>Continue</Button>
                </div>
            </div>
        );
    }
}

export default connector(ClearUploadQueueDialog);
